import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router } from '@angular/router';
import { FeatureFlagsService } from '@core/services/feature-flags.service';
import { RequestFormRoutePaths } from '@features/requests/request-form/types';

export const workflowsEnabledGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
) => {
  if (inject(FeatureFlagsService).workflowsEnabled) {
    return true;
  }

  const router = inject(Router);
  let currentRoute: ActivatedRouteSnapshot | null = route;

  while (currentRoute && !currentRoute.paramMap.has('requestNumber')) {
    currentRoute = currentRoute.parent;
  }

  const requestNumber = currentRoute?.paramMap.get('requestNumber');

  return requestNumber
    ? router.createUrlTree([
        '/requests',
        requestNumber,
        RequestFormRoutePaths.Summary,
      ])
    : router.createUrlTree(['/']);
};
